
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("gelCt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

var $42omo = parcelRequire("42omo");

/* eslint-disable @atlassian/tangerine/import/no-restricted-paths, @atlassian/tangerine/import/no-parent-imports */ 
var $3Npfo = parcelRequire("3Npfo");


var $k5HOq = parcelRequire("k5HOq");


var $chxrL = parcelRequire("chxrL");

const $f79ee28ee6e8037b$export$42b694a35bb75eda = (0, $3Npfo.default)((0, $chxrL.default));
var $f79ee28ee6e8037b$export$2e2bcd8739ae039 = (0, $k5HOq.default)($f79ee28ee6e8037b$export$42b694a35bb75eda, 'contextualSurvey');









var $k6CbH = parcelRequire("k6CbH");

const $fd2726ec51bc44d4$export$8423d11067fbf579 = (0, $3Npfo.default)((0, $k6CbH.default));
var $fd2726ec51bc44d4$export$2e2bcd8739ae039 = (0, $k5HOq.default)($fd2726ec51bc44d4$export$8423d11067fbf579, 'flag');









var $9IRwS = parcelRequire("9IRwS");

const $41237d9f13bb6bc3$export$404a075b2b026e91 = (0, $3Npfo.default)((0, $9IRwS.default));
var $41237d9f13bb6bc3$export$2e2bcd8739ae039 = (0, $k5HOq.default)($41237d9f13bb6bc3$export$404a075b2b026e91, 'modalDialog');


class $9beb89138b314685$export$2e2bcd8739ae039 extends (0, $42omo.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $41237d9f13bb6bc3$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fd2726ec51bc44d4$export$2e2bcd8739ae039), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f79ee28ee6e8037b$export$2e2bcd8739ae039), null));
    }
}
module.exports["default"] = $9beb89138b314685$export$2e2bcd8739ae039;
module.exports["EngagementMessages"] = $9beb89138b314685$export$2e2bcd8739ae039;

});

parcelRegister("ix8rI", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0346f3b2cad0330$export$2e2bcd8739ae039);
/* SurveyMarshal.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $7uLCZ = parcelRequire("7uLCZ");


var $dTk3A = parcelRequire("dTk3A");

const $e0346f3b2cad0330$var$surveyOffset = "var(--ds-space-600, 48px)";
const $e0346f3b2cad0330$var$animationDuration = 300;
const $e0346f3b2cad0330$var$offscreen = {
    // Hard-coded because there is no large enough space token and this component is not responsive.
    translateX: '488px',
    //survey container width + survey offset
    opacity: '0'
};
const $e0346f3b2cad0330$var$getAnimationProps = (state)=>{
    switch(state){
        case 'entered':
            return {
                translateX: '0',
                opacity: '1'
            };
        case 'entering':
        case 'unmounted':
        case 'exited':
        case 'exiting':
            return $e0346f3b2cad0330$var$offscreen;
    }
};
const $e0346f3b2cad0330$var$transitionBaseStyles = null;
function $e0346f3b2cad0330$export$2e2bcd8739ae039(props) {
    const { children: children, shouldShow: shouldShow } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7uLCZ.default), {
        in: shouldShow,
        timeout: $e0346f3b2cad0330$var$animationDuration,
        unmountOnExit: true,
        children: (state)=>{
            const { translateX: translateX, opacity: opacity } = $e0346f3b2cad0330$var$getAnimationProps(state);
            return /*#__PURE__*/ (0, $l998X.jsx)("div", {
                style: {
                    opacity: opacity,
                    transition: `all ${$e0346f3b2cad0330$var$animationDuration}ms ease-in-out`,
                    zIndex: (0, $dTk3A.layers).flag(),
                    transform: `translateX(${translateX})`
                },
                className: (0, $gMc0m.default)([
                    "_kqsw1n9t _1xi2oahv _94n5oahv _k8m01rjc"
                ]),
                children: children()
            });
        }
    });
}

});

parcelRegister("bfcUl", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $4KS7f = parcelRequire("4KS7f");

var $boHsq = parcelRequire("boHsq");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $804cB = parcelRequire("804cB");


var $dVmRp = parcelRequire("dVmRp");


var $9BPJm = parcelRequire("9BPJm");

class $6b4e4ecd5b980279$export$2e2bcd8739ae039 extends (0, $42omo.Component) {
    render() {
        const { actions: _actions, children: children, heading: heading, experimental_shouldShowPrimaryButtonOnRight: // All of the following props except `...rest` are unused but were being
        // spread into the Modal, which it does not accept.
        experimental_shouldShowPrimaryButtonOnRight, footer: footer, header: header, image: image, ...rest } = this.props;
        const Header = this.headerComponent(this.props);
        const Footer = this.footerComponent(this.props);
        const CustomHeader = ()=>{
            const { titleId: titleId } = (0, $804cB.useModal)();
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $dVmRp.ModalHeading), {
                id: titleId,
                children: heading
            });
        };
        return(// TODO: This is a problem that needs solving: https://product-fabric.atlassian.net/browse/DSP-22238
        // eslint-disable-next-line @atlaskit/design-system/use-modal-dialog-close-button
        /*#__PURE__*/ (0, $l998X.jsxs)((0, $8CZUH.default), {
            shouldCloseOnEscapePress: false,
            shouldCloseOnOverlayClick: false,
            shouldScrollInViewport: true,
            // @ts-ignore All of the following props were in the rest props, so I'm
            // making them explicit here even though the Modal doesn't accept them.
            experimental_shouldShowPrimaryButtonOnRight: experimental_shouldShowPrimaryButtonOnRight,
            footer: footer,
            header: header,
            heading: heading,
            image: image,
            ...rest,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)(Header, {}),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $1DHa6.default), {
                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $dVmRp.ModalBody), {
                        children: [
                            heading && /*#__PURE__*/ (0, $l998X.jsx)(CustomHeader, {}),
                            children
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)(Footer, {})
            ]
        }));
    }
    constructor(...args){
        super(...args);
        this.headerComponent = (props)=>{
            const { header: HeaderElement, image: src } = props;
            const ImageElement = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $dVmRp.ModalImage), {
                    src: src,
                    alt: ""
                });
            return HeaderElement || ImageElement;
        };
        this.footerComponent = (props)=>{
            const { footer: FooterElement, actions: actionList, experimental_shouldShowPrimaryButtonOnRight: experimental_shouldShowPrimaryButtonOnRight = false } = props;
            const ActionsElement = ()=>actionList ? /*#__PURE__*/ (0, $l998X.jsx)((0, $boHsq.default).Provider, {
                    value: (0, $9BPJm.modalButtonTheme),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $dVmRp.ModalActionContainer), {
                        shouldReverseButtonOrder: experimental_shouldShowPrimaryButtonOnRight,
                        children: actionList.map(({ text: text, key: key, ...rest }, idx)=>{
                            const variant = idx ? 'subtle-link' : 'primary';
                            return /*#__PURE__*/ (0, $l998X.jsx)((0, $dVmRp.ModalActionItem), {
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $4KS7f.default), {
                                    appearance: variant,
                                    autoFocus: !idx,
                                    ...rest,
                                    children: text
                                })
                            }, key || (typeof text === 'string' ? text : `${idx}`));
                        })
                    })
                }) : null;
            return FooterElement || ActionsElement;
        };
    }
}
module.exports["default"] = $6b4e4ecd5b980279$export$2e2bcd8739ae039;

});

parcelRegister("dVmRp", function(module, exports) {
/* modal.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gdv5Z = parcelRequire("gdv5Z");

const $51071d0057ab1254$var$modalBodyStyles = null;
const $51071d0057ab1254$var$modalHeadingStyles = null;
const $51071d0057ab1254$var$modalImageStyles = null;
const $51071d0057ab1254$var$modalActionContainerStyles = null;
const $51071d0057ab1254$var$modalActionContainerReversedStyles = null;
const $51071d0057ab1254$var$modalActionItemStyles = {
    root: "_6rth1b66 _1pfhze3t _12l21b66 _ahbq1b66"
}; /**
    * __Modal body__
    *
    * @internal
    */ 
const $51071d0057ab1254$export$cb540d8b0ef7906c = ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            "_85i51jfw _1q511jfw _y4tipxbi _bozgpxbi _y3gn1h6o"
        ]),
        children: children
    }); /**
                                                                                                                 * __Modal heading__
                                                                                                                 *
                                                                                                                 * @internal
                                                                                                                 */ 
const $51071d0057ab1254$export$9af27c346834c182 = ({ children: children, id: id })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("h1", {
        id: id,
        className: (0, $gMc0m.default)([
            "_11c81af2 _syaz1kw7 _6rthu2gc"
        ]),
        children: children
    });
}; /**
    * __Modal image__
    *
    * @internal
    */ 
const $51071d0057ab1254$export$1355685fd5f8d257 = ({ alt: alt, src: src })=>/*#__PURE__*/ (0, $l998X.jsx)("img", {
        alt: alt,
        src: src,
        className: (0, $gMc0m.default)([
            "_1bsb1osq _4t3i1wug _5fbcfajl _1s1gfajl _j722idpf"
        ])
    }); /**
                                                                                                                                        * __Modal action container__
                                                                                                                                        *
                                                                                                                                        * @internal
                                                                                                                                        */ 
const $51071d0057ab1254$export$633dda6b40ac1ac3 = ({ children: children, shouldReverseButtonOrder: shouldReverseButtonOrder })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            "_2lx2vrvc _1n261g80 _1e0c1txw _1bah1h6o _85i514no _1q51ze3t _y4ti1jfw _bozg1jfw",
            shouldReverseButtonOrder && "_2lx21sbv"
        ]),
        children: children
    }); /**
          * __Modal action item__
          *
          * @internal
          */ 
const $51071d0057ab1254$export$c245e9f76e3299b1 = ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $51071d0057ab1254$var$modalActionItemStyles.root,
        children: children
    });
module.exports["ModalBody"] = $51071d0057ab1254$export$cb540d8b0ef7906c;
module.exports["ModalHeading"] = $51071d0057ab1254$export$9af27c346834c182;
module.exports["ModalImage"] = $51071d0057ab1254$export$1355685fd5f8d257;
module.exports["ModalActionContainer"] = $51071d0057ab1254$export$633dda6b40ac1ac3;
module.exports["ModalActionItem"] = $51071d0057ab1254$export$c245e9f76e3299b1;

});

parcelRegister("6rSJC", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fb3kw = parcelRequire("fb3kw");

/**
 * __Checkbox field__
 *
 * A checkbox field is a form field that lets users select an item. Users can check or uncheck the checkbox.
 *
 * - [Examples] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Code] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Usage] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 */ const $aabc54d8ecf8c9ec$var$CheckboxField = ({ children: children, defaultIsChecked: defaultIsChecked = false, isDisabled: isDisabled, isRequired: isRequired, label: label, name: name, value: value })=>{
    // Maintains a memoised list of the default values
    const defaultValue = (0, $42omo.useCallback)((currentValue = [])=>defaultIsChecked && value !== undefined ? [
            ...currentValue,
            value
        ] : currentValue, [
        value,
        defaultIsChecked
    ]);
    return value !== undefined ? /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
        defaultValue: defaultValue,
        isDisabled: isDisabled,
        isRequired: isRequired,
        label: label,
        name: name,
        transform: (event, currentValue)=>!Array.isArray(event) && event.currentTarget.checked && currentValue ? [
                ...currentValue,
                value
            ] : currentValue.filter((v)=>v !== value),
        children: ({ fieldProps: { value: fieldValue, onChange: onChange, ...otherFieldProps }, ...others })=>children({
                fieldProps: {
                    ...otherFieldProps,
                    // Setting to any because it's typed weirdly at the field level
                    onChange: (v)=>onChange(v),
                    isChecked: !!fieldValue.find((v)=>v === value),
                    value: value
                },
                ...others
            })
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
        defaultValue: defaultIsChecked,
        isDisabled: isDisabled,
        isRequired: isRequired,
        label: label,
        name: name,
        transform: (event)=>typeof event === 'boolean' ? event : event.currentTarget.checked,
        children: ({ fieldProps: { value: fieldValue, onChange: onChange, ...otherFieldProps }, ...others })=>children({
                fieldProps: {
                    ...otherFieldProps,
                    // Setting to any because it's typed weirdly at the field level
                    onChange: (v)=>onChange(v),
                    isChecked: fieldValue,
                    value: value
                },
                ...others
            })
    });
};
var $aabc54d8ecf8c9ec$export$2e2bcd8739ae039 = $aabc54d8ecf8c9ec$var$CheckboxField;
module.exports["default"] = $aabc54d8ecf8c9ec$export$2e2bcd8739ae039;

});

parcelRegister("chxrL", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca1e6be685765484$export$2e2bcd8739ae039);
/* eslint-disable @atlassian/tangerine/import/no-restricted-paths, @atlassian/tangerine/import/no-parent-imports */ 
var $42omo = parcelRequire("42omo");


var $ix8rI = parcelRequire("ix8rI");


var $ll2sR = parcelRequire("ll2sR");

/* eslint-disable @typescript-eslint/no-unused-vars, no-unused-vars -- Deprecated API stubs retain public signature for compatibility */ async function $87a9e2a96c22d0ca$export$a19b74191e00c5e(_stargateUrl, _cloudId, _flagKey, _userKey) {
    return {
        status: false,
        lastSeenDate: ''
    };
}
async function $87a9e2a96c22d0ca$export$5e165df1e30a1331(_stargateUrl, _cloudId, _flagKey, _userKey) {
    return Promise.resolve();
}






var $bOUx6 = parcelRequire("bOUx6");

const $f221bb4589e9d781$var$flagKey = 'atlassian_research_group_mailinglist_actioned';
class $f221bb4589e9d781$export$2e2bcd8739ae039 extends (0, $42omo.PureComponent) {
    firePrimaryClickEvent() {
        this.props.fireClickEvent('primary');
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bOUx6.default), {
            onDismiss: this.onDismiss,
            getUserHasAnsweredMailingList: this.getUserHasAnsweredMailingList,
            onMailingListAnswer: this.onMailingListAnswer,
            onSubmit: this.onSubmit,
            ...this.props
        });
    }
    constructor(...args){
        super(...args);
        this.onDismiss = (onDismissArgs)=>{
            const { cloudId: cloudId, messageId: messageId, fireClickEvent: fireClickEvent, stargateUrl: stargateUrl, markAsSeenAndFatigued: markAsSeenAndFatigued, orgId: orgId, workspaceId: workspaceId } = this.props;
            if (onDismissArgs.trigger === (0, $bOUx6.DismissTrigger).Manual) markAsSeenAndFatigued({
                stargateUrl: stargateUrl,
                cloudId: cloudId,
                messageId: messageId,
                orgId: orgId,
                workspaceId: workspaceId
            });
            fireClickEvent('dismiss');
        };
        this.getUserHasAnsweredMailingList = async ()=>{
            const { stargateUrl: stargateUrl, aaid: aaid, cloudId: cloudId, getFlag: getFlag } = this.props;
            try {
                await getFlag(stargateUrl, cloudId, $f221bb4589e9d781$var$flagKey, aaid);
                return Promise.resolve(false);
            } catch  {
                return Promise.resolve(true);
            }
        };
        this.onSubmit = async (formValues)=>{
            const { cloudId: cloudId, messageId: messageId, question: question, statement: statement, stargateUrl: stargateUrl, markAsSeenAndFatigued: markAsSeenAndFatigued, sendUserResponse: sendUserResponse, orgId: orgId, workspaceId: workspaceId } = this.props;
            const { canContact: canContact, feedbackScore: feedbackScore, writtenFeedback: writtenFeedback } = formValues;
            const payload = {
                responseType: 'ACCEPTANCE_SURVEY',
                properties: {
                    surveyTimestamp: Date.now(),
                    contextualQuestion: question,
                    contextualStatement: statement,
                    quantitativeResponse: feedbackScore,
                    qualitativeResponse: writtenFeedback,
                    contactable: canContact
                }
            };
            markAsSeenAndFatigued({
                stargateUrl: stargateUrl,
                cloudId: cloudId,
                messageId: messageId,
                orgId: orgId,
                workspaceId: workspaceId
            });
            this.firePrimaryClickEvent();
            // Resolving the promise to ensure that spinner of Submit button does not spin forever in case of errors
            return sendUserResponse(cloudId, stargateUrl, messageId, payload).catch(()=>Promise.resolve());
        };
        this.onMailingListAnswer = async (answer)=>{
            const { aaid: aaid, cloudId: cloudId, stargateUrl: stargateUrl, messageId: messageId, sendUserResponse: sendUserResponse, setFlag: setFlag } = this.props;
            const payload = {
                responseType: 'MAILING_LIST_RESPONSE',
                properties: {}
            };
            setFlag(stargateUrl, cloudId, $f221bb4589e9d781$var$flagKey, aaid);
            if (!answer) return;
            return sendUserResponse(cloudId, stargateUrl, messageId, payload);
        };
    }
}


function $ca1e6be685765484$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ix8rI.default), {
        shouldShow: true
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f221bb4589e9d781$export$2e2bcd8739ae039), {
            markAsSeenAndFatigued: (0, $ll2sR.markAsSeenAndFatigued),
            sendUserResponse: (0, $ll2sR.sendUserResponse),
            getFlag: (0, $87a9e2a96c22d0ca$export$a19b74191e00c5e),
            setFlag: (0, $87a9e2a96c22d0ca$export$5e165df1e30a1331),
            ...props
        }));
}

});

parcelRegister("k6CbH", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hQNhB = parcelRequire("hQNhB");


var $eCEXz = parcelRequire("eCEXz");

var $6uGcC = parcelRequire("6uGcC");


var $7cTWR = parcelRequire("7cTWR");


var $9A5yV = parcelRequire("9A5yV");

/* eslint-disable @atlassian/tangerine/import/no-relative-package-imports, @atlassian/tangerine/import/no-restricted-paths, @atlassian/tangerine/import/entry-points, @atlassian/tangerine/import/no-parent-imports */ 
var $imt6g = parcelRequire("imt6g");


var $1yB28 = parcelRequire("1yB28");


var $9aGns = parcelRequire("9aGns");


var $7yOcR = parcelRequire("7yOcR");


var $a3fRD = parcelRequire("a3fRD");


var $eXmBZ = parcelRequire("eXmBZ");


var $ebrpi = parcelRequire("ebrpi");


var $6fnsQ = parcelRequire("6fnsQ");

const $46a50094144098af$var$flagMapping = {
    success: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($imt6g))),
        label: 'success',
        color: `var(--ds-icon-success, ${(0, $6fnsQ).G300})`
    },
    error: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))),
        label: 'error',
        color: `var(--ds-icon-danger, ${(0, $6fnsQ).R300})`
    },
    info: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))),
        label: 'info',
        color: `var(--ds-icon-information, ${(0, $6fnsQ).T300})`
    },
    warning: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))),
        label: 'warning',
        color: `var(--ds-icon-warning, ${(0, $6fnsQ).Y300})`
    },
    smallInfo: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))),
        label: 'info',
        color: `var(--ds-icon-discovery, ${(0, $6fnsQ).P300})`
    },
    comment: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($1yB28))),
        label: 'comment',
        color: `var(--ds-icon, ${(0, $6fnsQ).N300})`
    },
    download: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($9aGns))),
        label: 'download',
        color: `var(--ds-icon, ${(0, $6fnsQ).N300})`
    },
    feedback: {
        component: (0, (/*@__PURE__*/$parcel$interopDefault($7yOcR))),
        label: 'comment',
        color: `var(--ds-icon, ${(0, $6fnsQ).N300})`
    }
};
var $46a50094144098af$export$2e2bcd8739ae039 = $46a50094144098af$var$flagMapping;


class $1ee124a78f413427$export$2e2bcd8739ae039 extends (0, $42omo.Component) {
    onClickActionHandler(action) {
        if (action && action.type === (0, $7cTWR.buttonActionTypes).LINK && action.data) window.open(action.data.url, action.data.target);
    }
    render() {
        const { title: title, body: body, primaryText: primaryText, secondaryText: secondaryText, icon: icon } = this.props;
        const actions = [
            {
                content: primaryText,
                onClick: this.onPrimaryClick
            }
        ];
        if (secondaryText) actions.push({
            content: secondaryText,
            onClick: this.onSecondaryClick
        });
        const selectedIcon = (0, $46a50094144098af$export$2e2bcd8739ae039)[icon];
        const FlagIconComponent = selectedIcon && selectedIcon.component;
        const FlagIcon = FlagIconComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(FlagIconComponent, {
            label: selectedIcon.label,
            color: selectedIcon.color,
            spacing: "spacious"
        }) : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6uGcC.default), {
            onDismissed: this.onDismiss
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eCEXz.default), {
            id: "engagement-flag",
            appearance: "normal",
            icon: FlagIcon,
            title: title,
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9A5yV.default), {
                html: body
            }),
            actions: actions
        }));
    }
    constructor(...args){
        super(...args);
        this.onDismiss = ()=>{
            this.props.fireClickEvent('dismiss');
        };
        this.onPrimaryClick = ()=>{
            const { fireClickEvent: fireClickEvent, primaryAction: primaryAction } = this.props;
            fireClickEvent('primary');
            this.onClickActionHandler(primaryAction);
        };
        this.onSecondaryClick = ()=>{
            const { fireClickEvent: fireClickEvent, secondaryAction: secondaryAction } = this.props;
            fireClickEvent('secondary');
            this.onClickActionHandler(secondaryAction);
        };
    }
}
$1ee124a78f413427$export$2e2bcd8739ae039.defaultProps = {
    fireClickEvent: (0, (/*@__PURE__*/$parcel$interopDefault($hQNhB))),
    primaryText: null,
    primaryAction: null,
    secondaryText: null,
    secondaryAction: null,
    icon: 'smallInfo'
};
module.exports["default"] = $1ee124a78f413427$export$2e2bcd8739ae039;

});

parcelRegister("9IRwS", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bfcUl = parcelRequire("bfcUl");


var $7cTWR = parcelRequire("7cTWR");


var $9A5yV = parcelRequire("9A5yV");

function $b7ee03706fbccc7a$var$header() {
    return null;
}
class $b7ee03706fbccc7a$export$2e2bcd8739ae039 extends (0, $42omo.Component) {
    getActionButton(action, text, onClick) {
        return {
            text: text,
            onClick: (e)=>{
                if (action.type === (0, $7cTWR.buttonActionTypes).LINK && action.data) window.open(action.data.url, action.data.target);
                onClick(e);
            }
        };
    }
    getActions() {
        const { primaryAction: primaryAction, primaryText: primaryText, secondaryAction: secondaryAction, secondaryText: secondaryText } = this.props;
        const actions = [];
        if (primaryAction && primaryText) actions.push(this.getActionButton(primaryAction, primaryText, this.onPrimaryAction));
        if (secondaryAction && secondaryText) actions.push(this.getActionButton(secondaryAction, secondaryText, this.onSecondaryAction));
        return actions;
    }
    getAdditionalModalProps() {
        const props = {};
        const { imageSrc: imageSrc } = this.props;
        if (imageSrc) props.image = imageSrc;
        else props.header = $b7ee03706fbccc7a$var$header;
        return props;
    }
    render() {
        const { title: title, body: body } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bfcUl.default), {
            actions: this.getActions(),
            heading: title,
            ...this.getAdditionalModalProps()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9A5yV.default), {
            html: body
        }));
    }
    constructor(...args){
        super(...args);
        this.onPrimaryAction = ()=>{
            this.props.fireClickEvent('primary');
        };
        this.onSecondaryAction = ()=>{
            this.props.fireClickEvent('secondary');
        };
    }
}
module.exports["default"] = $b7ee03706fbccc7a$export$2e2bcd8739ae039;

});


//# sourceMappingURL=engagement-messages.fb4f41fa.js.map
